var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';

import styles from './styles.less';

var NavDots = function (_Component) {
  _inherits(NavDots, _Component);

  function NavDots() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NavDots);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NavDots.__proto__ || Object.getPrototypeOf(NavDots)).call.apply(_ref, [this].concat(args))), _this), _this.createDots = function () {
      var _this$props = _this.props,
          amount = _this$props.amount,
          current = _this$props.current,
          clickable = _this$props.clickable;


      var dots = [];

      for (var i = 0; i < amount; ++i) {
        dots.push(React.createElement('div', {
          key: i,
          className: styles.dot + ' ' + (current === i ? styles.active : '') + ' ' + (clickable ? styles.clickable : ''),
          'data-index-number': i,
          onClick: _this.activate,
          role: 'button'
        }));
      }

      return dots;
    }, _this.activate = function (e) {
      var _this$props2 = _this.props,
          clickable = _this$props2.clickable,
          onChange = _this$props2.onChange;

      if (clickable) {
        onChange(Number(e.target.dataset.indexNumber), 1);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NavDots, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;


      return React.createElement(
        'div',
        { className: styles.container + ' ' + className },
        this.createDots()
      );
    }
  }]);

  return NavDots;
}(Component);

NavDots.defaultProps = {
  current: 0,
  amount: 4,
  clickable: true,

  className: '',

  onChange: function onChange() {}
};

NavDots.propTypes = process.env.NODE_ENV !== "production" ? {
  current: PropTypes.number,
  amount: PropTypes.number,
  clickable: PropTypes.bool,

  className: PropTypes.string,

  onChange: PropTypes.func
} : {};

export default NavDots;